import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";

const SubcategoriesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("lookups_subcategories.list_title"),
            createBtnTitle: can_create && t("lookups_subcategories.add"),
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "localized_data.en.name",
                Header: t("lookups_subcategories.name_en"),
                sort: true,
                sortKey: "name",
                sortLang: "en",
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("lookups_subcategories.name_ar"),
                sort: true,
              },
              {
                accessor: "created_at",
                Header: t("details.created_at"),
                sort: true,
              },
              {
                accessor: "updated_at",
                Header: t("details.updated_at"),
                sort: true,
              },
              {
                accessor: "display_priority",
                Header: t("lookups_categories.display_priority"),
                sort: true,
              },
              {
                accessor: "is_featured",
                Header: t("lookups_categories.is_featured"),
                sort: true,
              },
              {
                accessor: "is_active_label",
                Header: t("lookups_categories.is_active"),
                sort: true,
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: true,
            searchInputPlaceholder: t(
              "lookups_subcategories.search_placeholder",
            ),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList,
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(t),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id
              ? t("lookups_subcategories.edit")
              : t("lookups_subcategories.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default SubcategoriesTemplate;
